import { Event, EventType } from "./Event";

import type { IAddProductDetailViewEvent } from "./types";

export class AddProductDetailViewEvent extends Event {
  constructor({
    itemId,
    tracking,
    customEventProperties,
  }: IAddProductDetailViewEvent) {
    super({
      event_type: EventType.product_detail_view,
      event_properties: {
        item_id: itemId,
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
